// FILE: client/src/actions/portfolioActions.js

import * as P from "../constants/portfolioConstants";
import api from "../utils/axiosInstance";
import { getApiErrorMessage } from "../utils/errorMessages";

const authHeader = (getState) => {
  const state = typeof getState === "function" ? getState() : {};
  const userInfo = state.userAuth?.userInfo || state.userLogin?.userInfo || {};
  const token = userInfo?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const encodePath = (value = "") =>
  encodeURIComponent(String(value || "").trim());

/** Public list (for /production page) */
export const listPortfolio =
  (section = "production") =>
  async (dispatch) => {
    try {
      dispatch({ type: P.PORTFOLIO_LIST_REQUEST });
      const { data } = await api.get(
        `/portfolio?section=${encodeURIComponent(section)}`,
      );
      dispatch({ type: P.PORTFOLIO_LIST_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: P.PORTFOLIO_LIST_FAIL,
        payload: getApiErrorMessage(error, {
          fallback:
            "We could not load portfolio items right now. Please try again later.",
        }),
      });
    }
  };

/** Admin list */

export const listPortfolioAdmin =
  (section = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: P.PORTFOLIO_ADMIN_LIST_REQUEST });

      const qs = section ? `?section=${encodeURIComponent(section)}` : "";

      const { data } = await api.get(`/portfolio/admin${qs}`, {
        headers: authHeader(getState),
      });

      dispatch({
        type: P.PORTFOLIO_ADMIN_LIST_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      const payload = getApiErrorMessage(error, {
        fallback:
          "We could not load admin portfolio items right now. Please try again later.",
      });

      dispatch({
        type: P.PORTFOLIO_ADMIN_LIST_FAIL,
        payload,
      });

      throw new Error(payload);
    }
  };

/** Admin details */
export const getPortfolioDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: P.PORTFOLIO_DETAILS_REQUEST });
    const { data } = await api.get(`/portfolio/admin/${encodePath(id)}`, {
      headers: authHeader(getState),
    });
    dispatch({ type: P.PORTFOLIO_DETAILS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: P.PORTFOLIO_DETAILS_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not load this portfolio item right now. Please try again later.",
      }),
    });
  }
};

/** Admin create */
export const createPortfolio = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: P.PORTFOLIO_CREATE_REQUEST });
    const { data } = await api.post(`/portfolio/admin`, payload, {
      headers: authHeader(getState),
    });
    dispatch({ type: P.PORTFOLIO_CREATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: P.PORTFOLIO_CREATE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not create this portfolio item right now. Please try again later.",
      }),
    });
  }
};

/** Admin update */
export const updatePortfolio = (id, patch) => async (dispatch, getState) => {
  try {
    dispatch({ type: P.PORTFOLIO_UPDATE_REQUEST });
    const { data } = await api.put(
      `/portfolio/admin/${encodePath(id)}`,
      patch,
      {
        headers: authHeader(getState),
      },
    );
    dispatch({ type: P.PORTFOLIO_UPDATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: P.PORTFOLIO_UPDATE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not update this portfolio item right now. Please try again later.",
      }),
    });
  }
};

/** Admin delete */
export const deletePortfolio = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: P.PORTFOLIO_DELETE_REQUEST });
    const { data } = await api.delete(`/portfolio/admin/${encodePath(id)}`, {
      headers: authHeader(getState),
    });
    dispatch({ type: P.PORTFOLIO_DELETE_SUCCESS });
    return data;
  } catch (error) {
    dispatch({
      type: P.PORTFOLIO_DELETE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not delete this portfolio item right now. Please try again later.",
      }),
    });
  }
};
